import React from 'react';

import {
  Typography
} from '@mui/material';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  terms: {
    height: '400px',
    overflow: 'scroll'
  }
});

const DisputePolicy  = (props) => {
  const classes = useClasses(styles);

  return (
    <React.Fragment>
      <Typography
        variant="h4"
      >
        DataMerch Dispute Policy
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Last Modified: 02-25-2026
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        I. PURPOSE AND SCOPE
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Datamerch LLC (“DataMerch”) operates an online information sharing database (the "Services") where authorized funding organizations ("Customers") share data regarding commercial entity accounts ("Merchants"). This Dispute Policy outlines the procedures for receiving, reviewing, and processing disputes regarding the accuracy or validity of Records listed on the Site. By submitting a Dispute (as defined below), uploading materials, requesting a review, or otherwise engaging with the DataMerch dispute process, the Merchant and its representatives agree to be bound by this Dispute Policy in its entirety, including the indemnification, limitations of liability, and arbitration provisions set forth below.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        This policy applies to:
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        1. <b>Merchants:</b> Commercial entities seeking to dispute a Record listed on DataMerch.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        2. <b>Customers:</b> Users who submit or post Customer Data and are responsible for the accuracy of their Submissions.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <i>Note for Customers: Your use of the Services is also governed by the DataMerch Terms of Use Agreement (TOU) and Privacy Policy. In the event of a conflict regarding dispute processing, this Policy controls.</i>
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        II. DEFINITIONS
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        To ensure clarity for all parties, the following definitions apply to this Policy:
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Merchant:</b> A commercial entity (including corporations, LLCs, partnerships, and sole proprietorships) that is the subject of a Record. DataMerch views these solely as commercial entities and never as individual consumers.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Customer (or Funder):</b> The funding organization or authorized user that submitted the Record to DataMerch.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Record:</b> Information, data, or content submitted by a Customer regarding a Merchant.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Dispute:</b> A formal inquiry submitted by a Merchant challenging the accuracy or validity of a Record.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        III. DISPUTE ELIGIBILITY GUIDELINES
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        DataMerch accepts and processes disputes that meet specific criteria to ensure the integrity of the database. We will accept a dispute if:
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Authorized Representative:</b> The dispute is submitted by the Merchant (business owner) or the Merchants authorized representative.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Sufficient Information:</b> The submission includes the business name, contact information, Employment Identification Number (EIN), and specific details regarding the Record in question.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Marketplace Issue:</b> The dispute relates to a commercial transaction or service issue arising from the relationship between the Merchant and the Customer.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        We do NOT process disputes that include:
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Abusive Language:</b> Complaints containing profane, abusive, or threatening language.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Criminal Allegations:</b> Complaints solely seeking criminal penalties or findings of criminal violations regarding the Customer (the funding organization) who originally entered the Record subject to dispute.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        IV. MERCHANT SUBMISSION STANDARDS
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        By submitting a Dispute to DataMerch, the submitter certifies and agrees to the following:
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Authority:</b> You have the full legal authority to act on behalf of the Merchant.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Accuracy:</b> All information, statements, and attachments provided in the Dispute are true and accurate to the best of your knowledge.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Rights:</b> You possess the necessary rights and permissions to upload any attachments or evidence provided.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Lawful Content:</b> Your submission does not contain any material that is abusive, unlawful, defamatory, or infringing on the rights of third parties.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        V. THE DISPUTE PROCESS
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        DataMerch follows a structured process to ensure fairness and accuracy.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>1. Submission and Intake.</b> The Merchant must complete a Dispute Form to initiate a case. DataMerch will review the submission to ensure it meets the eligibility guidelines outlined in Section III.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>2. Record Identification and Direction.</b> Upon acceptance of the dispute, DataMerch will internally locate the entry and review the Record. We will inform the Merchant of the information listed and direct the Merchant to contact the Customer (the funding organization) who originally entered the Record.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>3. Investigation and Cooperation.</b> If necessary, DataMerch will contact the Customer directly to investigate the dispute.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Customer Obligations:</b> Customers agree to maintain independent records of all data posted. If a Merchant challenges the accuracy of a Record, the Customer must fully cooperate with DataMerch. This includes communicating regarding the challenged data and providing proof of accuracy, if requested by DataMerch.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>4. Data Verification.</b> DataMerch gathers information from both the Merchant and the Customer to determine the status of the Record.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        VI. DISPUTE RESOLUTION AND RECORD UPDATES
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Based on the investigation, the Record will be handled in one of the following ways:
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>1. Removal of Records (Errors Only).</b> DataMerch will remove a Record only if it was entered in error and the Customer (Funder) requests its removal.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>2. Updates for Paid Collections.</b> Records regarding default or collections will NOT be removed simply because the collection is paid in full. Instead, an additional note will be added to the Record to reflect that the collection has a zero balance.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>3. Merchant Statements.</b> If the dispute remains unresolved or the Record is accurate but disputed by context, the Merchant is permitted to add a statement of disagreement to the Record to explain their position.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>4. Case Closure.</b> Once a resolution is reached (amendment, removal, or statement addition), DataMerch will inform the Merchant and, if necessary, the Customer, and close the dispute case.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        VII. RECORD RETENTION AND REMOVAL POLICY
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        DataMerch maintains a standard retention policy for commercial data as follows:
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>7-Year Removal:</b> A Merchant may request the removal of their information 7 years after the date the information was reported. DataMerch will remove the Record upon such a direct request by the business owner, subject to our discretion.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        VIII. DISCLAIMER OF WARRANTIES AND NO DUTY TO VERIFY
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>1. Administrative Role.</b> DataMerch is not a court, arbitrator, regulator, or fact finder. The dispute process is a voluntary administrative record management process. DataMerch does not independently verify the accuracy of information submitted by Customers or Merchants.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>2. As Is.</b> THE SERVICES AND DISPUTE PROCESS ARE PROVIDED "AS IS." DATAMERCH SPECIFICALLY DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF ACCURACY, COMPLETENESS, MERCHANTABILITY, OR FITNESS FOR A PARTICULAR PURPOSE.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>3. No Guarantee of Outcome.</b> DataMerch does not warrant that a Dispute will result in the removal or amendment of any Record.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        IX. INDEMNIFICATION
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>1. Merchant Indemnification.</b> Merchant agrees to indemnify, defend, and hold harmless DataMerch, its officers, directors, employees, and agents from and against any claims, damages, liabilities, and expenses (including attorneys fees) arising out of or related to: (a) the Merchant's Dispute submission, attachments, or Merchant statement; (b) any claim that materials provided by Merchant are false, misleading, defamatory, infringing, or unlawful; or (c) Merchant's misuse of the dispute process.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>2. Customer Indemnification.</b> Customers shall indemnify DataMerch in accordance with the indemnification provisions set forth in the TOU, including claims arising from Customer Data, Submissions, or violations of law.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>3. Mechanics.</b> DataMerch reserves the right to assume the exclusive defense and control of any matter subject to indemnification. You agree to cooperate with any reasonable requests assisting DataMerch's defense. You may not settle any claim that imposes any obligation on DataMerch without our prior written consent.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        X. LIMITATION OF LIABILITY AND RELEASE
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>1. Exclusion of Damages.</b> IN NO EVENT WILL DATAMERCH BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOST PROFITS, LOSS OF DATA, LOSS OF BUSINESS, OR REPUTATIONAL HARM, ARISING OUT OF OR IN CONNECTION WITH THE DISPUTE PROCESS OR THIS POLICY.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>2. Liability Cap.</b>
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>For Customers:</b> DataMerch's aggregate liability to a Customer shall not exceed the total amounts paid by Customer to DataMerch in the twelve (12) months preceding the event giving rise to the claim.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>For Merchants:</b> DataMerch's aggregate liability to a Merchant shall not exceed the lesser of one hundred dollars ($100) and the amounts paid by Merchant to DataMerch, if any, in the twelve (12) months preceding the event giving rise to the claim.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>3. Release.</b> Merchant hereby releases DataMerch and its affiliates from any and all claims, demands, and damages of every kind and nature, known and unknown, arising out of or in any way connected with DataMerch's administrative handling of the dispute process, related communications, or record updates, except in cases of proven willful misconduct by DataMerch.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        XI. REGULATORY DISCLAIMERS
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Commercial Data Only (No FCRA Applicability) DataMerch does not constitute a "consumer reporting agency" under the Fair Credit Reporting Act (FCRA). We only accept, store, and distribute data on commercial entities. Disputes regarding personal credit, consumer reports, or individual person data are not applicable, as DataMerch prohibits the submission of consumer data.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        XII. DISPUTES WITH DATAMERCH; GOVERNING LAW AND ARBITRATION
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>1. Governing Law.</b> This Policy shall be governed by the internal laws of Florida without giving effect to any choice or conflict of law provision.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>2. Binding Arbitration.</b> ANY DISPUTE BETWEEN MERCHANT AND DATAMERCH RELATING TO THIS POLICY OR THE DISPUTE PROCESS WILL BE RESOLVED EXCLUSIVELY AND FINALLY BY BINDING ARBITRATION ADMINISTERED BY JAMS OR AAA BEFORE A SINGLE ARBITRATOR.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>3. Class Action Waiver.</b> UNLESS OTHERWISE PROHIBITED BY LAW, THE ARBITRATION WILL BE CONDUCTED ON AN INDIVIDUAL BASIS AND WILL NOT BE COMMENCED AS A CLASS ARBITRATION. CLASS ACTION PROCEDURES SHALL NOT APPLY.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>4. Venue.</b> Exclusive jurisdiction and venue for any disputes not subject to arbitration shall be in the courts located in the state of Florida.
      </Typography>
    </React.Fragment>
  )
}

export default DisputePolicy;
